/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createE } from '../../factoriesAny.js';
export var eDependencies = {
  BigNumberDependencies,
  createE
};